module.exports = __webpack_public_path__ + "img/sq-last.e4b10824.png";